export default __webpack_public_path__ + "static/about-us-image-2a3e6f57cc3ae7f699946caf1baa7858.png";